import http from 'hub-http/clients/apiClient';
import enviro from 'enviro';
import { createRpcClientV2 } from 'rpc-client-utils';
import { validateHubsRpc } from '../../__generated__/chirp/com/hubspot/partner/demo/rpc/PartnerDemoHubValidationRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
const GATEWAY_PORTAL_ID = enviro.isProd() ? 53 : 99535353;
export function validateDemoHubs(accounts) {
  const hubIdsByHublet = {};
  for (const account of accounts) {
    const {
      hublet
    } = account;
    if (hublet) {
      if (!hubIdsByHublet[hublet]) {
        hubIdsByHublet[hublet] = [];
      }
      hubIdsByHublet[hublet].push(account.id);
    }
  }
  return rpcClient.call(validateHubsRpc, {
    portalId: GATEWAY_PORTAL_ID,
    request: {
      hubIdsByHublet
    }
  }).then(response => {
    var _response$results;
    return (_response$results = response.results) !== null && _response$results !== void 0 ? _response$results : {};
  });
}